import { render, staticRenderFns } from "./ClockedCalendar.vue?vue&type=template&id=4403cc45"
import script from "./ClockedCalendar.vue?vue&type=script&lang=js"
export * from "./ClockedCalendar.vue?vue&type=script&lang=js"
import style0 from "./ClockedCalendar.vue?vue&type=style&index=0&id=4403cc45&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports